import type React from 'react'

import { textColorVariants, textVariants } from '@/lib/constants'
import { cn } from '@/lib/styles'

type FontSize = keyof typeof textVariants
type TextColor = keyof typeof textColorVariants

export const Paragraph = ({
  children,
  className,
  fontSize = 'bodyRegularLarge',
  textColor = 'black',
}: {
  className?: string
  children?: React.ReactNode
  fontSize?: FontSize
  textColor?: TextColor
}) => {
  const textStyle = textVariants[fontSize]
  const textColorClassName = textColorVariants[textColor]

  const combinedClassName = cn(textStyle, textColorClassName, className)

  return <p className={combinedClassName}>{children}</p>
}
